import smartSolveApi from './instances/smartsolve';

export const getAppConfigs = async () => {
  try {
    const appOptions = smartSolveApi.post('/getapplicationoptions', {});
    const fetchLanguages = smartSolveApi.post('/getlanguages');
    const appSettings = smartSolveApi.post('/getapplicationsettings');
    const orgHierarchy = smartSolveApi.post('/organizationhierarchysetup');

    const [
      appOptionsResponse,
      fetchLanguagesResponse,
      appSettingsResponse,
      orgHierarchyResponse,
    ] = await Promise.all([appOptions, fetchLanguages, appSettings, orgHierarchy]);

    return {
      appOptionsResponse: appOptionsResponse.data,
      fetchLanguagesResponse: fetchLanguagesResponse.data,
      appSettingsResponse: appSettingsResponse.data,
      orgHierarchyResponse: orgHierarchyResponse.data,
    };
  } catch (e) {
    throw new Error(`getAppConfigs() failed: ${e}`);
  }
};
